function extractCategories(response) {
  const categories = response?.data?.attributes?.resume?.categories || [];
  return categories.map((cat) => ({
    category: cat.category,
    category_id: cat.category_id,
  }));
}

export default extractCategories;
